import { AccordionPanel, AccordionHeader } from '@mds/mds-reactjs-library';
import { isDemoEnabled } from '../../Utility/UserUtils';

const highlightText = (text, term) => {
    if (!term) return text;
    return text.replace(
        new RegExp(term, 'gi'),
        match => `<span class="highlight">${match}</span>`
    );
};

const IsDemoFeatureEnabled = isDemoEnabled();

const FAQItem = ({ faq, searchTerm }) => {
    const answer = IsDemoFeatureEnabled
        ? faq.ans.replace(/Panorama@mckinsey\.com/gi, '')
        : faq.ans;

    return (
        <AccordionPanel
            defaultExpanded={
                searchTerm && faq.ans.toLowerCase().includes(searchTerm.toLowerCase())
            }
            className="accordian"
            key={faq.id}
        >
            <AccordionHeader>
                <p
                    className="faq-question"
                    dangerouslySetInnerHTML={{
                        __html: highlightText(faq.ques, searchTerm),
                    }}
                />
            </AccordionHeader>
            <div
                className="faq-answer"
                dangerouslySetInnerHTML={{
                    __html: highlightText(answer, searchTerm),
                }}
            />
        </AccordionPanel>
    );
};

export default FAQItem;